/**
 * Deterministic sentinel IDs mirrored from the API
 * (`services/api/src/seed/sentinels.py`). These UUIDs are pinned forever —
 * every environment shares the same identity — so mirroring the constant
 * here is safe and avoids an extra round-trip just to learn a fixed id.
 *
 * Keep in sync with the Python source of truth.
 */

/** The 'Unassigned' holder team — where "Remove from team" moves a person,
 *  since `employees.team_id` is NOT NULL (there is no team-less state). */
export const UNASSIGNED_TEAM_ID = '00000000-0000-4000-8000-00000000ad03'
